import { atom } from "jotai";
import {
  DEFAULT_FILTERS,
  DEFAULT_PAGE,
  DEFAULT_ROWS_PER_PAGE,
} from "constants/paginationConstants";

export const driverRequestsFiltersAtom = atom({
  ...DEFAULT_FILTERS,
});

export const driverPageAtom = atom(DEFAULT_PAGE);
export const driverRowsPerPageAtom = atom(DEFAULT_ROWS_PER_PAGE);
